<template>
    <div class="leave-index">
        <v-card class="rounded-lg" flat>
            <!-- Tiêu đề thẻ và Nút hành động in PDF -->
            <v-card-title class="text-h6 font-weight-bold py-3 px-4">
                Phiếu lương cá nhân
                <v-spacer></v-spacer>
                <v-btn v-if="activeTab === 0 && !isLoadingV2 && itemsV2.length > 0" small color="amber darken-2" dark
                    class="mr-2" @click="exportPDF">
                    <v-icon small left>mdi-printer</v-icon> In PDF
                </v-btn>
            </v-card-title>

            <v-card-subtitle class="text-center font-weight-bold grey--text text--darken-2 pb-2">
                Tháng: {{ monthTitleShort }}
            </v-card-subtitle>

            <!-- Tabs phân chia bản lương V1, V2 -->
            <v-tabs v-model="activeTab" background-color="transparent" color="teal darken-4" class="px-4">
                <v-tab class="font-weight-bold">Phiếu Lương V2</v-tab>
                <v-tab class="font-weight-bold">Phiếu Lương V1</v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab">
                <!-- TAB BẢN LƯƠNG V2 (DÀNG DYNAMIC ĐỌC CỘT TỪ RESPONSE) -->
                <v-tab-item class="pt-4 px-4 pb-6" style="background-color: #fafafa;">
                    <div v-if="isLoadingV2" class="text-center py-10">
                        <v-progress-circular indeterminate color="teal darken-4"></v-progress-circular>
                        <div class="caption grey--text mt-2">Đang tải dữ liệu lương V2...</div>
                    </div>

                    <div v-else-if="itemsV2.length === 0" class="text-center py-10 grey--text">
                        <v-icon large color="grey lighten-1">mdi-alert-circle-outline</v-icon>
                        <div class="subtitle-2 mt-2">Chưa có thông tin phiếu lương V2 cho tháng này</div>
                    </div>

                    <div v-else :id="'salary-slip-' + (getValByIndex(1) || 'PhieuLuong')"
                        class="salary-slip-container pa-4 white elevation-1 rounded-lg">
                        <!-- Header Phiếu Lương -->
                        <div class="text-center mb-6">
                            <div class="headline font-weight-bold teal--text text--darken-4 text-uppercase">Phiếu Lương
                            </div>
                            <div class="subtitle-1 font-weight-bold grey--text text--darken-2">Tháng {{ monthTitleShort
                                }}</div>
                        </div>

                        <!-- Thông tin nhân viên -->
                        <v-row class="mb-2">
                            <v-col cols="6" class="py-1">
                                <div class="d-flex"><span class="font-weight-bold mr-2 text-no-wrap"
                                        style="width: 180px; min-width: 180px; display: inline-block;">{{ getLabelByIndex(2, 'Họ và tên') }}:</span> {{ getValByIndex(2) }}</div>
                                <div class="d-flex"><span class="font-weight-bold mr-2 text-no-wrap"
                                        style="width: 180px; min-width: 180px; display: inline-block;">{{ getLabelByIndex(4, 'Chi nhánh/Phòng ban') }}:</span> {{ getValByIndex(4) }}</div>
                                <div class="d-flex"><span class="font-weight-bold mr-2 text-no-wrap"
                                        style="width: 180px; min-width: 180px; display: inline-block;">{{ getLabelByIndex(3, 'Chức vụ/Vị trí') }}:</span> {{ getValByIndex(3) }}</div>
                                <div class="d-flex"><span class="font-weight-bold mr-2 text-no-wrap"
                                        style="width: 180px; min-width: 180px; display: inline-block;">{{ getLabelByIndex(5, 'Số tài khoản') }}:</span> {{ getValByIndex(5) }}</div>
                            </v-col>
                            <v-col cols="6" class="py-1">
                                <div class="d-flex"><span class="font-weight-bold mr-2 text-no-wrap"
                                        style="width: 140px; min-width: 140px; display: inline-block;">{{ getLabelByIndex(1, 'MSNV') }}:</span> {{ getValByIndex(1) }}</div>
                                <div class="d-flex"><span class="font-weight-bold mr-2 text-no-wrap"
                                        style="width: 140px; min-width: 140px; display: inline-block;">{{ getLabelByIndex(6, 'Bộ phận') }}:</span> {{ getValByIndex(6) }}</div>
                                <div class="d-flex"><span class="font-weight-bold mr-2 text-no-wrap"
                                        style="width: 140px; min-width: 140px; display: inline-block;">{{ getLabelByIndex(7, 'Tại Ngân hàng') }}:</span> {{ getValByIndex(7) }}</div>
                            </v-col>
                        </v-row>

                        <div class="red--text text--darken-3 font-italic caption mb-4">
                            *** Lưu ý: Vì tính bảo mật, mỗi cá nhân cam kết không tiết lộ thông tin tiền lương, nếu vi
                            phạm sẽ bị xử lý theo quy định của Công ty.
                        </div>

                        <!-- Bảng Chi tiết 2 Cột -->
                        <v-row class="mb-4">
                            <!-- Cột bên trái: Chấm công & Khấu trừ -->
                            <v-col cols="6" class="pr-2 py-0">
                                <table class="salary-table w-100">
                                    <thead>
                                        <tr class="amber darken-2 white--text">
                                            <th colspan="2" class="text-left px-2 py-1">Chấm công</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(8, 'Ngày công chuẩn') }}</td>
                                            <td class="text-right px-2 py-1 font-weight-bold">{{ getValByIndex(8) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(9, 'Ngày công tính lương') }}</td>
                                            <td class="text-right px-2 py-1 font-weight-bold">{{ getValByIndex(9) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(12, 'Giờ làm thêm') }}</td>
                                            <td class="text-right px-2 py-1 font-weight-bold">{{ getValByIndex(12) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(13, 'Giờ tính tăng ca') }}</td>
                                            <td class="text-right px-2 py-1 font-weight-bold">{{ getValByIndex(13) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(14, 'Giờ Lễ/tết') }}</td>
                                            <td class="text-right px-2 py-1 font-weight-bold">{{ getValByIndex(14) }}
                                            </td>
                                        </tr>

                                        <tr class="amber darken-2 white--text">
                                            <th colspan="2" class="text-left px-2 py-1">Các khoản khấu trừ</th>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(33, 'Tạm ứng cơm/Lương') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(33) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(34, 'BHXH (10.5%)') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(34) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(35, 'Thuế TNCN') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(35) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(36, 'Truy thu/ Thu hồi') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(36) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(54, 'Truy thu Thuế TNCN 2025 (QT thuế 2025)') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(54) }}</td>
                                        </tr>

                                        <!-- Footer cột trái -->
                                        <tr
                                            class="grey lighten-4 red--text text--darken-3 font-weight-bold font-italic">
                                            <td class="px-2 py-1">{{ getLabelByIndex(56, 'Tổng Khấu trừ (1)') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(56) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </v-col>

                            <!-- Cột bên phải: Thu nhập chuẩn & thực tế -->
                            <v-col cols="6" class="pl-2 py-0">
                                <table class="salary-table w-100">
                                    <thead>
                                        <tr class="amber darken-2 white--text">
                                            <th colspan="2" class="text-left px-2 py-1">Các khoản thu nhập chuẩn</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(15, 'Mức lương chính') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(15) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(16, 'Mức Phụ cấp công việc') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(16) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(17, 'Mức Phụ cấp trách nhiệm') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(17) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(18, 'Mức Hỗ trợ Điện thoại') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(18) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(19, 'Mức Hỗ trợ khoản công tác') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(19) }}</td>
                                        </tr>

                                        <tr class="amber darken-2 white--text">
                                            <th colspan="2" class="text-left px-2 py-1">Các khoản thu nhập thực tế</th>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(20, 'Lương chính') }}</td>
                                            <td class="text-right px-2 py-1 font-weight-bold">{{ getValByIndex(20) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(21, 'Phụ cấp công việc') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(21) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(22, 'Phụ cấp trách nhiệm') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(22) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(23, 'Hỗ trợ Điện thoại') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(23) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(24, 'Hỗ trợ khoản công tác') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(24) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(25, 'Lương làm thêm') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(25) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(26, 'Lương tăng ca') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(26) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(27, 'Lương Lễ/tết') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(27) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(29, 'Hỗ trợ đào tạo') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(29) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(30, 'Hỗ trợ đi lại') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(30) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(31, 'Hỗ trợ nhà ở') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(31) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(32, 'Hỗ trợ xăng xe') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(32) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(28, 'Tiền ăn giữa ca') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(28) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(38, 'Truy lãnh/hoàn trả') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(38) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(51, 'Tổng thưởng') }}</td>
                                            <td class="text-right px-2 py-1 font-weight-bold">{{ getValByIndex(51) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(41, 'Phép năm hoàn lại') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(41) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(40, 'Trợ cấp thôi việc/ mất việc') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(40) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(47, 'Thưởng lương Tháng 13') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(47) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">{{ getLabelByIndex(53, 'Hoàn thuế TNCN 2025 (QT thuế 2025)') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(53) }}</td>
                                        </tr>

                                        <!-- Footer cột phải -->
                                        <tr
                                            class="grey lighten-4 red--text text--darken-3 font-weight-bold font-italic">
                                            <td class="px-2 py-1">{{ getLabelByIndex(55, 'Tổng thu nhập (2)') }}</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(55) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </v-col>
                        </v-row>

                        <!-- Lương thực nhận -->
                        <div class="blue-box pa-3 rounded mb-4">
                            <div class="d-flex justify-space-between align-center">
                                <span class="title font-weight-bold blue--text text--darken-3">{{ getLabelByIndex(57, 'Lương thực nhận (2)-(1)') }}:</span>
                                <span class="headline font-weight-bold blue--text text--darken-3">{{ getValByIndex(57)
                                    }}</span>
                            </div>
                            <div class="caption font-weight-bold grey--text text--darken-3 mt-1">
                                Bằng chữ: <span class="font-italic">{{ netSalaryInWords }}</span>
                            </div>
                        </div>

                        <!-- Chú thích -->
                        <div class="caption mb-4" v-if="getValByIndex(37) || getValByIndex(39)">
                            <div v-if="getValByIndex(37)">(*) {{ getValByIndex(37) }}</div>
                            <div v-if="getValByIndex(39)">(**) {{ getValByIndex(39) }}</div>
                        </div>

                        <!-- Bảng phụ 1: Chi tiết Thưởng bán hàng -->
                        <div class="mb-4" v-if="hasBonusDetails">
                            <div class="subtitle-1 font-weight-bold red--text text--darken-3 text-center mb-2">
                                Chi tiết Thưởng bán hàng Tháng {{ monthTitleShort }}
                            </div>
                            <table class="salary-table w-100">
                                <thead class="grey lighten-3 font-weight-bold">
                                    <tr>
                                        <th class="text-left px-2 py-1">Các khoản thưởng</th>
                                        <th class="text-right px-2 py-1" style="width: 180px;">Số tiền thưởng</th>
                                        <th class="text-left px-2 py-1" style="width: 250px;">Ghi chú</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="px-2 py-1">{{ getLabelByIndex(42, 'Thưởng Doanh thu') }}</td>
                                        <td class="text-right px-2 py-1">{{ getValByIndex(42) }}</td>
                                        <td class="px-2 py-1"></td>
                                    </tr>
                                    <tr>
                                        <td class="px-2 py-1">{{ getLabelByIndex(44, 'Thưởng GP') }}</td>
                                        <td class="text-right px-2 py-1">{{ getValByIndex(44) }}</td>
                                        <td class="px-2 py-1"></td>
                                    </tr>
                                    <tr>
                                        <td class="px-2 py-1">{{ getLabelByIndex(43, 'Thưởng đơn hàng online') }}</td>
                                        <td class="text-right px-2 py-1">{{ getValByIndex(43) }}</td>
                                        <td class="px-2 py-1"></td>
                                    </tr>
                                    <tr>
                                        <td class="px-2 py-1">{{ getLabelByIndex(48, 'Thưởng chuyên môn') }}</td>
                                        <td class="text-right px-2 py-1">{{ getValByIndex(48) }}</td>
                                        <td class="px-2 py-1"></td>
                                    </tr>
                                    <tr>
                                        <td class="px-2 py-1">{{ getLabelByIndex(49, 'Thưởng khác') }}</td>
                                        <td class="text-right px-2 py-1">{{ getValByIndex(49) }}</td>
                                        <td class="px-2 py-1"></td>
                                    </tr>
                                    <tr class="grey lighten-4 font-weight-bold font-italic">
                                        <td class="px-2 py-1">{{ getLabelByIndex(51, 'Tổng các khoản thưởng') }}</td>
                                        <td class="text-right px-2 py-1">{{ getValByIndex(51) }}</td>
                                        <td class="px-2 py-1"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Bảng phụ 2: Chi tiết Thưởng lương Tháng 13 -->
                        <div v-if="hasMonth13Details" class="mt-4">
                            <div
                                class="subtitle-1 font-weight-bold amber--text text--darken-4 mb-2 pa-1 yellow lighten-4 rounded">
                                Chi tiết Thưởng lương Tháng 13 năm 2025
                            </div>
                            <table class="salary-table w-100">
                                <tbody>
                                    <tr>
                                        <td class="px-2 py-1 font-weight-bold">{{ getLabelByIndex(45, 'Trung bình lương năm 2025') }}</td>
                                        <td class="text-right px-2 py-1 font-weight-bold" style="width: 180px;">{{
                                            getValByIndex(45) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="px-2 py-1 font-weight-bold">{{ getLabelByIndex(46, 'Số tháng làm việc thực tế') }}</td>
                                        <td class="text-right px-2 py-1 font-weight-bold">{{ getValByIndex(46) }}</td>
                                    </tr>
                                    <tr class="yellow lighten-4 font-weight-bold">
                                        <td class="px-2 py-1">{{ getLabelByIndex(47, 'Thưởng lương Tháng 13 năm 2025') }}</td>
                                        <td class="text-right px-2 py-1 red--text">{{ getValByIndex(47) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </v-tab-item>

                <!-- TAB BẢN LƯƠNG V1 (PHẢN CỐ ĐỊNH NHƯ CŨ) -->
                <v-tab-item>
                    <v-card-text class="primary--text">
                        <v-row style="max-width: 800px;">
                            <v-col cols="6">
                                <table class="" style="width: 100%;">
                                    <tr>
                                        <td class="font-weight-bold">Họ và tên: </td>
                                        <td>{{ item.ten }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Chi nhánh/Phòng ban: </td>
                                        <td>{{ item.chiNhanh }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Chức vụ/Vị trí ban: </td>
                                        <td>{{ item.chucVu }}</td>
                                    </tr>
                                </table>
                            </v-col>
                            <v-col cols="6">
                                <table class="" style="width: 100%;">
                                    <tr>
                                        <td class="font-weight-bold">Mã NS: </td>
                                        <td>{{ item.maNS }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Bộ phận: </td>
                                        <td>{{ item.boPhan }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Tại ngân hàng: </td>
                                        <td>{{ item.nganHang }}</td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-simple-table style="border: 1px solid; border-collapse: collapse;">
                                    <tbody>
                                        <tr>
                                            <td class="font-weight-bold">Ngày công chuẩn</td>
                                            <td>{{ formatNumber(item.ncCoBan + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Ngày công tính lương</td>
                                            <td>{{ formatNumber(item.ncThucTe + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Giờ làm thêm</td>
                                            <td>{{ formatNumber(item.gcLamThem + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Giờ tính tăng ca</td>
                                            <td>{{ formatNumber(item.gcTangCa + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Giờ lễ/tết</td>
                                            <td>{{ formatNumber(item.gcLeTet + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold orange darken-2 white--text" colspan="2">Các
                                                khoản khấu trừ</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Tạm ứng cơm/lương</td>
                                            <td>{{ formatNumber(item.ktTamUng + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">BHXH</td>
                                            <td>{{ formatNumber(item.ktBHXH + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Thuế TNCN 2025</td>
                                            <td>{{ formatNumber(item.ktTNCN + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Truy thu/Thu hồi <br> => Xem mục (*) bên dưới
                                            </td>
                                            <td>{{ formatNumber(item.ktTruyThu + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2"></td>
                                        </tr>
                                        <tr>
                                            <td colspan="2"></td>
                                        </tr>
                                        <tr>
                                            <td colspan="2"></td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">
                                                Truy thu Thuế TNCN 2025
                                                (Quyết toán thuế TNCN 2025)</td>
                                            <td>{{ formatNumber(item.truyThu2023 + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold red--text">Tổng khấu trừ (1)</td>
                                            <td class="red--text">{{ formatNumber(Number(item.tongKhauTru + 0.0)) }}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-simple-table style="border: 1px solid; border-collapse: collapse;">
                                    <tbody>
                                        <tr>
                                            <td class="font-weight-bold">Lương cơ bản</td>
                                            <td>{{ formatNumber(item.lCoBan + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Lương thực tế</td>
                                            <td>{{ formatNumber(item.lThucTe + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Lương làm thêm</td>
                                            <td>{{ formatNumber(item.lLamThem + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Lương tăng ca</td>
                                            <td>{{ formatNumber(item.lTangCa + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Lương Lễ/Tết</td>
                                            <td>{{ formatNumber(item.lLeTet + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Phụ cấp khu vực</td>
                                            <td>{{ formatNumber(item.pcKhuVuc + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Phụ cấp đào tạo</td>
                                            <td>{{ formatNumber(item.pcDaoTao + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Phụ cấp công việc</td>
                                            <td>{{ formatNumber(item.pcCongViec + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Phụ cấp chuyên môn (DSPT)</td>
                                            <td>{{ formatNumber(item.pcChuyenMon + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Tiền ăn giữa ca</td>
                                            <td>{{ formatNumber(item.thuongTienAn + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Truy lãnh/Hoàn trả <br> => Xem mục (**) bên
                                                dưới</td>
                                            <td>{{ formatNumber(item.thuongTruyLanh + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Thưởng bán hàng <br>
                                                => Xem chi tiết ở bên dưới </td>
                                            <td>{{ formatNumber(item.thuongSauThatThoat + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Trợ cấp thôi việc/mất việc</td>
                                            <td>{{ formatNumber(item.thoiViec + 0.0) }}</td>
                                        </tr>

                                        <tr>
                                            <td class="font-weight-bold">
                                                Hoàn thuế TNCN 2025
                                                (Quyết toán thuế TNCN 2025)</td>
                                            <td>{{ formatNumber(item.hoanThue2023 + 0.0) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold red--text">Tổng lương (2)</td>
                                            <td class="font-weight-bold red--text">{{ formatNumber(item.tongLuong + 0.0)
                                                }}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                        <v-card outlined elevation="0" rounded="lg" class="mt-4" style="border: 2px solid black;">
                            <v-card-text>
                                <h2><span class="primary--text font-weight-bold">Lương thực nhận (2)-(1): </span> {{
                                    formatNumber(item.thucNhan + 0.0)}}</h2>
                                <h2><span class="red--text font-weight-bold">Bằng chữ: </span> {{
                                    formatNumber(item.bangChu)}}</h2>
                            </v-card-text>
                        </v-card>

                        <v-subheader class=" text--darken-4 font-weight-medium">
                            (*) {{ item.ktTruyThu ? item.ktGhiChuTruyThu : '' }}
                        </v-subheader>

                        <v-subheader class=" text--darken-4 font-weight-medium">
                            (**) {{ item.thuongTruyLanh ? item.ghiChuTruyLanh : '' }}
                        </v-subheader>

                        <v-subheader class="orange--text text--darken-4 font-weight-medium">
                            <i>*Lưu ý: Do tính bảo mật về tiền lương nên Anh/Chị TBP/ASM cung cấp riêng cho từng cá nhân
                                nhận lương. Mỗi cá nhân cam kết không tiết lộ thông tin tiền lương, nếu vi phạm sẽ xử lý
                                theo quy định của Công ty.</i>
                        </v-subheader>

                        <v-row>
                            <v-col cols="12" md="12">
                                <v-subheader class="font-weight-bold red--text text--darken-4">Chi tiết Thưởng lương
                                    Tháng 13 năm 2025</v-subheader>
                                <v-simple-table style="border: 1px solid; border-collapse: collapse;">
                                    <tbody>
                                        <tr>
                                            <td class="font-weight-bold">Trung bình lương 2025</td>
                                            <td>{{ formatNumber(item.thatThoatTrongThang + 0.0) }}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Số tháng làm việc thực tế</td>
                                            <td>{{ formatNumber(item.thatThoatGhiNo + 0.0) }}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Thưởng lương tháng 13 năm 2025</td>
                                            <td>{{ formatNumber(item.tongThatThoat + 0.0) }}</td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                        </v-row>

                        <v-row v-show="true">
                            <v-col cols="12" md="12">
                                <v-subheader class="font-weight-bold red--text text--darken-4">1. Chi tiết khấu trừ thất
                                    thoát Tháng {{ monthTitleShort }}</v-subheader>
                                <v-simple-table style="border: 1px solid; border-collapse: collapse;">
                                    <tr>
                                        <th></th>
                                        <th>Số cấn trừ thất thoát</th>
                                        <th>Ghi chú</th>
                                    </tr>
                                    <tbody>
                                        <tr>
                                            <td class="font-weight-bold">Thất thoát trong tháng</td>
                                            <td>{{ formatNumber(item.thatThoatTrongThang + 0.0) }}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Thất thoát ghi nợ tháng trước</td>
                                            <td>{{ formatNumber(item.thatThoatGhiNo + 0.0) }}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Tổng thất thoát(1):</td>
                                            <td>{{ formatNumber(item.tongThatThoat + 0.0) }}</td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-subheader class="font-weight-bold red--text text--darken-4">2. Chi tiết Thưởng bán
                                    hàng Tháng {{ monthTitleShort }}</v-subheader>
                                <v-simple-table style="border: 1px solid; border-collapse: collapse;">
                                    <tr>
                                        <th></th>
                                        <th>Số tiền thưởng</th>
                                        <th>Ghi chú</th>
                                    </tr>
                                    <tbody>
                                        <tr>
                                            <td class="font-weight-bold">Thưởng Doanh thu</td>
                                            <td>{{ formatNumber(item.thuongDoanhThuBanDau + 0.0) }}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Thưởng GP</td>
                                            <td>{{ formatNumber(item.thuongGp + 0.0) }}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold">Thưởng zaloPay</td>
                                            <td>{{ formatNumber(item.zalo + 0.0) }}</td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-tab-item>
            </v-tabs-items>
        </v-card>

        <!-- ************** DELETE CONFIRMATION *************** -->
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="headline">Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogDelete = false">Thoát</v-btn>
                    <v-btn color="blue darken-1" text @click="cfmDeleteItem">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>


<script>
import * as moment from "moment/moment";
import CreateButton from '@/components/Crud/CreateButton';
import http from '@/components/services/http-common';
// import Create from './Create';
import DataFilter from '@/components/DataFilter.vue';

export default {
    name: 'Leave',
    components: {
        CreateButton,
        // "create-dialog": Create,
        "data-filter": DataFilter
    },
    watch: {
        tableParams: {
            handler(val) {
                this.fetchData();
                this.fetchCity();
            },
            deep: true,
        },
        filters: {
            handler(val) {
                this.tableParams.page = 1;
                this.fetchData();
            },
            deep: true,
        },
        month: {
            handler(val) {
                this.filters.from = moment(val, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
                this.filters.to = moment(val, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
            }
        }
    },

    computed: {
        webAllowed() {
            let user = localStorage.getItem("user");
            let webAllowed = localStorage.getItem("WebAllowed");
            user = JSON.parse(user);
            return webAllowed.includes(user.employeeCode);
        },
        params: function () {
            return { ...this.tableParams, ...this.filters }
        },
        monthTitle: function () {
            return moment(this.$route.params.id).format('DD/MM/YYYY')
        },
        monthTitleShort: function () {
            return moment(this.$route.params.id).format('MM.YYYY')
        },
        hasBonusDetails() {
            if (!this.itemsV2 || this.itemsV2.length === 0) return false;
            return !!(
                this.getValByIndex(42) ||
                this.getValByIndex(44) ||
                this.getValByIndex(43) ||
                this.getValByIndex(48) ||
                this.getValByIndex(49)
            );
        },
        hasMonth13Details() {
            if (!this.itemsV2 || this.itemsV2.length === 0) return false;
            return !!(
                this.getValByIndex(45) ||
                this.getValByIndex(46) ||
                this.getValByIndex(47)
            );
        },
        netSalaryInWords() {
            const rawVal = this.getValByIndex(57);
            if (!rawVal) return '';
            const rawStr = String(rawVal).replace(/,/g, '');
            const netSalary = parseFloat(rawStr);
            if (isNaN(netSalary)) return '';
            return this.convertNumberToWords(netSalary);
        }
    },
    data() {
        return {
            ROOT_URL: "EmployeeSalaryImports/",

            //HEADER DATA
            icon: {
                icon: "mdi-plus-thick",
                to: ""
            },

            //filters
            month: moment().format("YYYY-MM"),
            filters: {
                code: null,
                employeeName: null,
                from: moment().startOf("month").format("YYYY-MM-DD"),
                to: moment().endOf("month").format("YYYY-MM-DD"),
            },
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
            },
            rowCount: 0,

            //TABLE
            filterEmployeeCode: "",
            filterEmployeeName: "",
            filterDepartmentName: "",
            search: "",
            headers: [
                {
                    text: "Tháng", value: "month",
                    filter: value => {
                        console.log(value.includes(moment(this.search).format("YYYY-MM-DD")));
                        if (!this.search) return true

                        return this.formatDate(value).includes(this.search)
                    },
                },
                { text: "Mã NS", value: "maNS" },
                { text: "Tên NS", value: "ten" },
                { text: "Chức vụ", value: "chucVu" },
                { text: "Chi nhánh/Phòng ban", value: "chiNhanh", },
                { text: "STK", value: "stk" },
                { text: "Ngân Hàng", value: "nganHang" },
                { text: "Giờ công cơ bản", value: "gcCoBan" },
                { text: "Giờ công thực tế", value: "gcThucTe" },
                { text: "Giờ công làm thêm", value: "gcLamThem" },
                { text: "Giờ công tăng ca", value: "gcTangCa" },
                { text: "Giờ công lễ tết", value: "gcLeTet" },
                { text: "Khấu trừ tạm ứng", value: "ktTamUng" },
                { text: "Khấu trừ BHXH", value: "ktBHXH" },
                { text: "Khấu trừ TNCN", value: "ktTNCN" },
                { text: "Khấu trừ truy thu", value: "ktTruyThu" },
                { text: "Lương cơ bản", value: "lCoBan" },
                { text: "Lương thực tế", value: "lThucTe" },
                { text: "Lương làm thêm", value: "lLamThem" },
                { text: "Lương tăng ca", value: "lTangCa" },
                { text: "Lương lễ tết", value: "lLeTet" },
                { text: "Phụ cấp khu vực", value: "pcKhuVuc" },
                { text: "Phụ cấp đào tạo", value: "pcDaoTao" },
                { text: "Phụ cấp công tác", value: "pcCongTac" },
                { text: "Phụ cấp công việc", value: "pcCongViec" },
                { text: "Thưởng quý", value: "thuongQuy" },
                { text: "Thưởng tiền ăn", value: "thuongTienAn" },
                { text: "Thưởng truy lãnh", value: "thuongTruyLanh" },
                { text: "Tổng lương", value: "tongLuong" },
                { text: "Tổng khấu trừ", value: "tongKhauTru" },
                { text: "Thực nhận", value: "thucNhan" },
                { text: "Bằng chữ", value: "bangChu", width: "350px" },
            ],

            items: [],
            item: {},
            options: {},
            isLoading: true,

            //DIALOG
            dialog: {
                state: false,
                item: undefined,
            },
            dialogDelete: false,
            targetItem: {},
            activeTab: 0,
            itemsV2: [],
            isLoadingV2: true,
        }
    },

    methods: {
        formatDate(value) {
            return moment(value).format("DD/MM/YYYY");
        },
        formatNumber(value) {
            if (value == null)
                return ""
            return value.toLocaleString('en-US', { style: 'decimal' });
        },

        status(value) {
            let result = {};
            switch (value) {
                case 0: {
                    result.text = "Chờ duyệt";
                    result.color = "warning"
                    break;
                }
                case 1: {
                    result.text = "Đã duyệt"
                    result.color = "success"
                    break;
                }
                case 2: {
                    result.text = "Từ chối"
                    result.color = "error"
                    break;
                }
                default: {
                    result.text = "unknown"
                    break;
                }
            }
            return result;
        },

        //DATA JS
        fetchData() {
            let month = "2024-12-01"
            // console.log(this.$route.params.id)
            if (!!this.$route.params) {
                month = this.$route.params.id
            }
            return http.get(this.ROOT_URL + "employee/show", {
                params: {
                    month: moment(month).format("YYYY-MM-DD")
                }
            })
                .then(res => {
                    // this.items = res.data.data
                    this.item = res.data.data
                    console.log(this.item.pcCongViec)
                    // if(this.items.length != 1) {
                    //     alert("result error please reload page")
                    // }
                    this.isLoading = false;
                })
        },
        fetchDataV2() {
            let month = "2024-12-01";
            if (this.$route.params && this.$route.params.id) {
                month = this.$route.params.id;
            }

            let user = localStorage.getItem("user");
            if (!user) {
                this.isLoadingV2 = false;
                return Promise.resolve();
            }
            user = JSON.parse(user);
            const employeeCode = user.employeeCode;
            if (!employeeCode) {
                this.isLoadingV2 = false;
                return Promise.resolve();
            }

            this.isLoadingV2 = true;
            return http.get(this.ROOT_URL + "v2/" + employeeCode + "/" + moment(month).format("YYYY-MM-DD"))
                .then(res => {
                    this.itemsV2 = res.data.data || res.data || [];
                    console.log(this.itemsV2)
                    this.isLoadingV2 = false;
                })
                .catch(err => {
                    console.error("Error fetching V2 salary data:", err);
                    this.isLoadingV2 = false;
                });
        },
        getValByIndex(index) {
            if (!this.itemsV2 || this.itemsV2.length === 0) return '';
            const found = this.itemsV2.find(item => item.index === index);
            if (!found) return '';
            return found.type === 'Number' && typeof found.dataNumber === 'number'
                ? found.dataNumber.toLocaleString('en-US')
                : (found.dataText !== undefined && found.dataText !== null ? found.dataText : '');
        },
        getLabelByIndex(index, fallback = '') {
            if (!this.itemsV2 || this.itemsV2.length === 0) return fallback;
            const found = this.itemsV2.find(item => item.index === index);
            if (!found || !found.label) return fallback;
            return found.label;
        },
        convertNumberToWords(number) {
            if (number === 0) return "Không đồng";

            const units = ["", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];
            const classes = ["", "nghìn", "triệu", "tỷ", "nghìn tỷ", "triệu tỷ"];

            function readThreeDigits(n, showZeroHundreds) {
                let hundreds = Math.floor(n / 100);
                let tens = Math.floor((n % 100) / 10);
                let ones = n % 10;
                let res = "";

                if (hundreds > 0 || showZeroHundreds) {
                    res += units[hundreds] + " trăm ";
                }

                if (tens > 1) {
                    res += units[tens] + " mươi ";
                } else if (tens === 1) {
                    res += "mười ";
                } else if (tens === 0 && ones > 0 && (hundreds > 0 || showZeroHundreds)) {
                    res += "lẻ ";
                }

                if (ones === 1 && tens > 1) {
                    res += "mốt";
                } else if (ones === 5 && tens > 0) {
                    res += "lăm";
                } else if (ones > 0) {
                    res += units[ones];
                }

                return res.trim();
            }

            let strNumber = Math.abs(Math.round(number)).toString();
            let groups = [];
            while (strNumber.length > 0) {
                groups.push(strNumber.substring(Math.max(0, strNumber.length - 3)));
                strNumber = strNumber.substring(0, Math.max(0, strNumber.length - 3));
            }

            let wordGroups = [];
            for (let i = 0; i < groups.length; i++) {
                let n = parseInt(groups[i]);
                if (n === 0 && groups.length > 1) {
                    wordGroups.push("");
                    continue;
                }
                let showZeroHundreds = i < groups.length - 1;
                let groupWord = readThreeDigits(n, showZeroHundreds);
                if (groupWord) {
                    wordGroups.push(groupWord + " " + classes[i]);
                } else {
                    wordGroups.push("");
                }
            }

            let result = wordGroups.reverse().filter(x => x !== "").join(" ").trim();
            result = result.charAt(0).toUpperCase() + result.slice(1) + " đồng chẵn";
            return result.replace(/\s+/g, ' ').trim();
        },
        exportPDF() {
            const employeeId = this.getValByIndex(1) || 'PhieuLuong';
            const element = document.getElementById('salary-slip-' + employeeId);
            if (!element) {
                console.error("Salary slip element not found for ID:", employeeId);
                return;
            }

            const w = window.open('', '_blank');
            if (!w) {
                alert("Không thể mở cửa sổ in. Vui lòng cho phép trình duyệt hiển thị popup để tiếp tục!");
                return;
            }

            w.document.write(`
                <html>
                    <head>
                        <title>Phiếu Lương - Tháng ${this.monthTitleShort}</title>
                        <style>
                            body {
                                margin: 0;
                                padding: 20px;
                                font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
                                background: white;
                            }
                            .salary-slip-container {
                                width: 100%;
                                max-width: 800px;
                                margin: 0 auto;
                                padding: 20px;
                                border: 1px solid #e0e0e0;
                                box-shadow: none !important;
                            }
                            .salary-table {
                                width: 100%;
                                border-collapse: collapse;
                                margin-bottom: 8px;
                                font-size: 11px;
                            }
                            .salary-table th, .salary-table td {
                                border: 1px solid #d0d0d0;
                                padding: 6px 8px;
                                line-height: 1.2;
                            }
                            .salary-table th {
                                background-color: #d97706 !important;
                                color: white !important;
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                                font-weight: bold;
                            }
                            .grey.lighten-4 {
                                background-color: #f5f5f5 !important;
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                            }
                            .yellow.lighten-4 {
                                background-color: #fef3c7 !important;
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                            }
                            .blue-box {
                                border: 1px solid #b3d7ff;
                                background-color: #f0f7ff !important;
                                padding: 12px;
                                border-radius: 4px;
                                margin-top: 10px;
                                margin-bottom: 10px;
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                            }
                            .d-flex { display: flex; }
                            .justify-space-between { justify-content: space-between; }
                            .align-center { align-items: center; }
                            .text-center { text-align: center; }
                            .text-right { text-align: right; }
                            .font-weight-bold { font-weight: bold; }
                            .font-italic { font-style: italic; }
                            .headline { font-size: 20px; }
                            .title { font-size: 16px; }
                            .subtitle-1 { font-size: 14px; }
                            .caption { font-size: 11px; }
                            .mb-2 { margin-bottom: 8px; }
                            .mb-4 { margin-bottom: 16px; }
                            .mb-6 { margin-bottom: 24px; }
                            .mt-4 { margin-top: 16px; }
                            .py-1 { padding-top: 4px; padding-bottom: 4px; }
                            .px-2 { padding-left: 8px; padding-right: 8px; }
                            .w-100 { width: 100%; }
                            .row { display: flex; flex-wrap: wrap; margin-right: -12px; margin-left: -12px; }
                            .col-6 { flex: 0 0 50%; max-width: 50%; padding: 12px; box-sizing: border-box; }
                            .teal--text.text--darken-4 { color: #004d40 !important; }
                            .primary--text { color: #1976d2 !important; }
                            .blue--text.text--darken-3 { color: #1565c0 !important; }
                            .red--text.text--darken-3 { color: #c62828 !important; }
                            .amber--text.text--darken-4 { color: #ff8f00 !important; }
                            .text-no-wrap { white-space: nowrap; }
                            @page {
                                margin: 10mm;
                                size: A4 portrait;
                            }
                            @media print {
                                body { padding: 0; }
                                .salary-slip-container { border: none; }
                            }
                        </style>
                    </head>
                    <body>
                        ${element.innerHTML}
                    </body>
                </html>
            `);
            w.document.close();
            w.focus();
            setTimeout(function () {
                w.print();
                w.close();
            }, 600);
        },

        //DIALOG METHOD
        openDialog() {
            this.params = {
            }
        },
        closeHandler() {
            this.dialog = { state: false, item: undefined }
        },
        editItem(item) {
            this.dialog = { state: true, item: item }
        },
        deleteItem(item) {
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            http.delete(this.ROOT_URL + "undo/" + this.targetItem.id).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            }).catch(err => {
                switch (err.response.status) {
                    case 403: {
                        this.unauthorizeAlert();
                        this.dialogDelete = false;
                        break;
                    }
                    default:
                        break;
                }
            })
        },

    },

    created() {
        this.fetchData();
        this.fetchDataV2();
    }
}
</script>

<style scoped>
.salary-slip-container {
    font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    color: #333333;
    max-width: 800px;
    margin: 0 auto;
    border: 1px solid #e0e0e0;
}

.salary-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 8px;
    font-size: 0.8rem;
}

.salary-table th,
.salary-table td {
    border: 1px solid #d0d0d0;
    padding: 6px 8px;
    line-height: 1.2;
}

.salary-table th {
    font-weight: bold;
}

.salary-table td {
    color: #333333;
}

.blue-box {
    border: 1px solid #b3d7ff;
    background-color: #f0f7ff;
}

.w-100 {
    width: 100%;
}
</style>